import { useState, useEffect } from 'react';
import { getContactItemKey, isOrg } from '@web-common/components/util/contact';
const useContactOrgItemEffect = (params) => {
    const { list, callback, useContactId } = params;
    const [lastList, setLastList] = useState([]);
    useEffect(() => {
        const contactIdSet = new Set();
        const orgIdSet = new Set();
        list.forEach(item => {
            if (isOrg(item)) {
                orgIdSet.add(item.id);
            }
            else {
                contactIdSet.add(getContactItemKey(item, useContactId));
            }
        });
        const contactLastIdSet = new Set();
        const orgLastIdSet = new Set();
        lastList.forEach(item => {
            if (isOrg(item)) {
                orgLastIdSet.add(item.id);
            }
            else {
                contactLastIdSet.add(getContactItemKey(item, useContactId));
            }
        });
        if (contactIdSet.size !== contactLastIdSet.size || orgIdSet.size !== orgLastIdSet.size) {
            setLastList(list);
            callback();
        }
        else {
            const orgHasDiff = [...orgIdSet].some(orgId => !orgLastIdSet.has(orgId));
            if (orgHasDiff) {
                setLastList(list);
                callback();
            }
            else {
                const contactHasDiff = [...contactIdSet].some(orgId => !contactLastIdSet.has(orgId));
                if (contactHasDiff) {
                    setLastList(list);
                    callback();
                }
            }
        }
    }, [list]);
};
const useContactItemEffect = (list, callback, useContactId) => {
    useContactOrgItemEffect({ list, callback, useContactId });
};
export const useOrgItemEffect = (list, callback) => {
    useContactOrgItemEffect({ list, callback, useContactId: false });
};
export default useContactItemEffect;
